import ModuleCard from './template'
export default ModuleCard;
